module.exports = __webpack_public_path__ + "img/tn-timeline-misc-6.5b11434f.jpg";